<div
  class="message"
  [class.has-attachments]="attachments.length > 0"
  [ngClass]="{
    'from-other': currentUser.name !== comment.author,
    'from-author': currentUser.name === comment.author
  }">

  @if (attachments.length && (currentOrganizationId$ | async); as organizationId) {
    <div
      class="attachments-carousel-host"
      >
      <attachments-carousel
        [attachments]="attachments"
        [organizationId]="organizationId"
        [enablePanzoom]="false"
        [showOverlay]="false"
        [showSVG]="false"
        [allowRotate]="false"
        [allowDownload]="true"
        (contentHeightChanged)="onCommentAttachmentHeightChanged()">
      </attachments-carousel>
    </div>
  }

  @if (users$ | async; as users) {
    <p
      [innerHTML]="comment.text | mentionify:users | linkify">
    </p>
  }

  <div class="comment-infos">
    @if (comment.author) {
      <span>{{ comment.author }}&nbsp;-&nbsp;</span>
    }
    @if (refreshSince$ | async; as now) {
      {{ dateToTimestamp(comment.dateCreated) | since: now }}
    }
  </div>

</div>
